export const TTI_FROM_INVOCATION_SEVERITY_THRESHOLD_DEFAULTS = {
	NORMAL: 5000,
	DEGRADED: 8000,
};
